import { Report } from '@/api/generatedApi';
import { CopiableGridColDef } from '@/types/copiableColumn';
import { dateFormat } from '@/utils/format';
import {
  RenderReportName,
  RenderReportDetails,
  RenderReportStatus,
  RenderReportCreatedBy,
  RenderReportCreatedAt,
  RenderReportGroups,
} from './cellDefinitions';

export const reportColumns: CopiableGridColDef<Report>[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1.5,
    sortable: false,
    filterable: false,
    renderCell: RenderReportName,
    getCopyValue: row => row.name,
  },
  {
    field: 'groupCount',
    headerName: 'Groups',
    flex: 0.75,
    sortable: false,
    filterable: false,
    renderCell: RenderReportGroups,
    getCopyValue: row => String(row.groupCount ?? 0),
  },
  {
    field: 'details',
    headerName: 'Details',
    flex: 2.5,
    minWidth: 200,
    sortable: false,
    filterable: false,
    renderCell: RenderReportDetails,
    cellClassName: 'details-cell',
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: RenderReportCreatedBy,
    getCopyValue: row => row.creator?.email,
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: RenderReportCreatedAt,
    getCopyValue: row => (row.createdAt ? dateFormat(row.createdAt) : undefined),
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: RenderReportStatus,
    getCopyValue: row => row.status,
  },
];
